import React, { useState, useRef } from "react";
import {
  StyledCountrySelector,
  StyledCountrySelectorBody,
  StyledCountrySelectorDropdown,
  StyledCountrySelectorDropdownItem,
  StyledCountrySelectorItem,
  StyledArrow,
  StyledLabel,
} from "./CountrySelector.elements";
import { useOnOutsideClick } from "../../hooks";
import { ICONS } from "../../icons";
import { ReactComponent as CheckIcon} from "../../assets/icons/checkmark.svg";
import { Spinner } from "../Spinner/Spinner";

export interface CountryOption {
  code: string;
  name: string;
}

export interface CountrySelectorProps {
  value: string;
  onChange: (code: string) => void;
  options: CountryOption[];
  label?: string;
  placeholder?: string;
  loading?: boolean;
}

export function CountrySelector({
  value,
  onChange,
  options,
  label,
  placeholder = "Válassz országot",
  loading = false,
}: CountrySelectorProps) {
  const elementRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const selected = options.find((o) => o.code === value) || null;

  // useOnOutsideClick expects MutableRefObject<HTMLElement | undefined>
  useOnOutsideClick(
    { current: elementRef.current as HTMLElement | undefined },
    () => setIsOpen(false)
  );

  return (
    <StyledCountrySelector ref={elementRef}>
      {label &&<StyledLabel>{label}</StyledLabel>}
      <StyledCountrySelectorBody 
        disabled={loading}
        onClick={() => !loading && setIsOpen((o) => !o)}
      >
        <StyledCountrySelectorItem isPlaceholder={!selected}>
          {selected ? selected.name : placeholder}
        </StyledCountrySelectorItem>
        {loading ? (
          <Spinner size="small" />
        ) : (
          <StyledArrow
            src={ICONS.ArrowDownSVG}
            isOpen={isOpen}
          />
        )}
      </StyledCountrySelectorBody>
      <StyledCountrySelectorDropdown isOpen={isOpen && !loading}>
        {options.map((option) => (
          <StyledCountrySelectorDropdownItem
            key={option.code}
            selected={selected ? option.code === selected.code : false}
            onClick={() => {
              onChange(option.code);
              setIsOpen(false);
            }}
          >
            <StyledCountrySelectorItem>
              {option.name}
              {selected && option.code === selected.code && (
                <CheckIcon style={{ width: 20, height: 20 }} />
              )}
            </StyledCountrySelectorItem>
          </StyledCountrySelectorDropdownItem>
        ))}
      </StyledCountrySelectorDropdown>
    </StyledCountrySelector>
  );
}

export default CountrySelector;
